import { EnumProductType } from "gql/generated";

export const isStringProductType = (str: string) => {
  return Object.values(EnumProductType).includes(str as EnumProductType);
};
